import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

export const PUBLISH_ENVELOPE_QUERY_KEYS = [
  'envelopes',
  'envelope',
  'vault-items',
  'user-account-context',
  'billing-subscription',
]

export interface PublishEnvelopeResponse {
  withheldInvites: number
}

export const publishEnvelope = async (
  envelopeId: string,
): Promise<PublishEnvelopeResponse> => {
  const { data } = await apiClient.post<
    Partial<PublishEnvelopeResponse> | undefined
  >(`/v1/ecm/envelopes/${envelopeId}/publish`)
  return { withheldInvites: data?.withheldInvites ?? 0 }
}

export const usePublishEnvelope = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (envelopeId: string) => publishEnvelope(envelopeId),
    meta: {
      invalidatesQuery: PUBLISH_ENVELOPE_QUERY_KEYS,
      ...feedback,
    },
  })
}
